<template>
  <form
    class="request-password"
    :class="{ 'request-password--code-validation': step === 'verification' }"
    novalidate
    @submit.prevent="send"
  >
    <div
      v-if="step === 'request'"
      class="request-password__field"
      :class="{
        'request-password__field--error':
          !isValidEmail && isDirtyField('userEmail'),
      }"
    >
      <label for="userEmail"> E-mail </label>
      <input
        id="userEmail"
        v-model.trim="email"
        name="userEmail"
        type="email"
        @blur="setDirty('userEmail')"
        @focus="removeError('userEmail')"
      />
      <transition name="fade">
        <p
          v-if="!isValidEmail && isDirtyField('userEmail')"
          class="sign-in__field--warning"
        >
          E-mail inválido.
        </p>
      </transition>
    </div>

    <transition name="fade">
      <div
        v-if="step === 'verification'"
        class="request-password__field"
        :class="{
          'request-password__field--error':
            !isValidVerificationCode && isDirtyField('userVerificationCode'),
        }"
      >
        <label for="userVerificationCode">
          Insira o código recebido por e-mail
        </label>
        <input
          id="userVerificationCode"
          v-model.trim="verificationCode"
          name="userVerificationCode"
          type="text"
          maxlength="6"
          placeholder="------"
          @blur="setDirty('userVerificationCode')"
          @focus="removeError('userVerificationCode')"
        />
        <transition name="fade">
          <p
            v-if="
              !isValidVerificationCode && isDirtyField('userVerificationCode')
            "
            class="sign-in__field--warning"
          >
            Código inválido.
          </p>
        </transition>
      </div>
    </transition>

    <div class="sign-in__field">
      <button
        class="request-password__cta"
        :class="{
          'request-password__cta--disabled': !isValidFields || loading,
          'request-password__cta--loading': loading,
        }"
        :disabled="!isValidFields || loading"
        type="submit"
      >
        <span v-if="step === 'request'">
          {{ loading ? 'Enviando' : 'Enviar' }}
        </span>
        <span v-else>
          {{ loading ? 'Verificando' : 'Verificar' }}
        </span>
      </button>

      <transition name="fade">
        <p
          v-if="submitError"
          class="request-password__field--warning"
        >
          {{ submitError }}
        </p>
      </transition>
    </div>

    <div class="request-password__return">
      <button @click="$emit('handleFlow', 'signin')">Voltar</button>
    </div>
  </form>
</template>

<script>
import emailValidator from '@/validation/validators/email';
import errosLogin from '@/helpers/errorsLogin';

export default {
  name: 'RequestPassword',
  data() {
    return {
      email: '',
      verificationCode: '',
      dirtyFields: [],
      step: 'request',
      submitError: '',
      loading: false,
    };
  },
  computed: {
    isValidEmail() {
      return emailValidator(this.email);
    },
    isValidVerificationCode() {
      return /^\d{6}$/.test(this.verificationCode);
    },
    isValidFields() {
      return this.step === 'request'
        ? this.isValidEmail
        : this.isValidVerificationCode;
    },
  },
  methods: {
    setDirty(field) {
      if (!this.dirtyFields.includes(field)) {
        this.dirtyFields.push(field);
      }
    },
    isDirtyField(field) {
      return this.dirtyFields.includes(field);
    },
    removeError(field) {
      this.submitError = '';

      this.dirtyFields = this.dirtyFields.filter((item) => {
        return field !== item;
      });
    },
    request(userBody) {
      this.$store
        .dispatch('requestPassword', userBody)
        .then(() => {
          this.loading = false;
          this.step = 'verification';
        })
        .catch((err) => {
          this.loading = false;
          this.submitError = errosLogin(err.response?.data?.message);
        });
    },
    verifyCode(userBody) {
      this.$store
        .dispatch('verifyCode', userBody)
        .then((token) => {
          this.$store.commit('SET_RESET_TOKEN', token);
          this.$emit('handleFlow', 'reset');
        })
        .catch((err) => {
          this.loading = false;
          this.submitError = errosLogin(err.response?.data?.message);
        });
    },
    send() {
      this.loading = true;

      const userBody = { email: this.email };

      if (this.step === 'request') {
        this.request(userBody);
      } else if (this.step === 'verification') {
        userBody.code = this.verificationCode;
        this.verifyCode(userBody);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login .request-password {
  #userVerificationCode,
  #userVerificationCode::placeholder {
    text-align: center;
    letter-spacing: 20px;
    padding-left: 0;
    text-indent: -20px;
    direction: rtl;
  }

  &--code-validation {
    width: 300px;
    margin: auto;
  }
}
</style>
